;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesRegenerationStepsBar =  Marionette.ItemView.extend({
		template: JST.LeagueRegenerationStepsBar,
		ui:{
			'items': '.step'
		},
		initialize : function(){
			this.listenTo(APP.vent, 'step_bar:update', this.activateItem.bind(this));
		},
		activateItem : function(step){
			_.each(this.ui.items, function(item){
				if($(item).data('item') == step)
					$(item).addClass('active');
				else
					$(item).removeClass('active');
			});
		}
	});

}(window, APP, Backbone, Marionette, $, _));